/* to allow almost private methods */
/* eslint-disable no-underscore-dangle */
import isString from 'lodash-es/isString';
import isNull from 'lodash-es/isNull';
export const isStorageAvailable = () => {
    const key = 'cw-store-test';
    try {
        window.localStorage.setItem(key, '1');
        window.localStorage.removeItem(key);
        window.sessionStorage.setItem(key, '1');
        window.sessionStorage.removeItem(key);
        return true;
    }
    catch {
        return false;
    }
};
const storageAvailable = isStorageAvailable();
const context = (session) => session ? 'sessionStorage' : 'localStorage';
export function _makeGet(storageTest, session) {
    function func(key, defaultValue) {
        if (!storageTest) {
            return isString(defaultValue) ? defaultValue : null;
        }
        const value = window[context(session)].getItem(key);
        if (isNull(value)) {
            return isString(defaultValue) ? defaultValue : null;
        }
        return value;
    }
    return func;
}
/**
 * @ignore
 */
export function _makeSet(storageTest, session) {
    return (key, value) => {
        if (!storageTest) {
            return undefined;
        }
        return window[context(session)].setItem(key, value);
    };
}
/**
 * @ignore
 */
export function _makeRemove(storageTest, session) {
    return (key) => {
        if (!storageTest) {
            return undefined;
        }
        return window[context(session)].removeItem(key);
    };
}
export const get = _makeGet(storageAvailable);
export const set = _makeSet(storageAvailable);
export const remove = _makeRemove(storageAvailable);
export const getSession = _makeGet(storageAvailable, true);
export const setSession = _makeSet(storageAvailable, true);
export const removeSession = _makeRemove(storageAvailable, true);
